import { inject, injectable } from "inversify";
import { ConnectJobModel, GuidSelectModel, ICPLJobsClient, JobFiltersModel } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IJobsService {
  getJobs(jobFiltersModel: JobFiltersModel): Promise<ConnectJobModel[]>;
  getJob(jobID: number, taskSeqID: number): Promise<ConnectJobModel>;
  getJobStatusTypeSelectModels(): Promise<GuidSelectModel[]>;
}

@injectable()
export class JobsService implements IJobsService {
  @inject(SERVICE_TYPES.CPLJobsClient) cplJobTypesClient!: ICPLJobsClient;

  async getJobs(jobFiltersModel: JobFiltersModel): Promise<ConnectJobModel[]> {
    return this.cplJobTypesClient.getJobs(jobFiltersModel);
  }

  async getJob(jobID: number, taskSeqID: number): Promise<ConnectJobModel> {
    return this.cplJobTypesClient.getJob(jobID, taskSeqID);
  }

  async getJobStatusTypeSelectModels(): Promise<GuidSelectModel[]> {
    return this.cplJobTypesClient.getJobStatusTypeSelectModels();
  }
}
